import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router';
import { AdministrationPage } from '../pages/administration/AdministrationPage';
import { UserDetailPage } from '../pages/administration/UserDetailPage';
import { UserSearchPage } from '../pages/administration/UserSearchPage';
import type { BreadcrumbHandle } from './breadcrumbs';

export const administrationRoutes: RouteObject = {
  path: 'administration',
  element: <Outlet />,
  handle: {
    breadcrumb: () => ({ label: 'Administration', to: '/administration' }),
  } satisfies BreadcrumbHandle,
  children: [
    {
      index: true,
      Component: AdministrationPage,
    },
    {
      path: 'users',
      element: <Outlet />,
      handle: {
        breadcrumb: () => ({ label: 'User Management', to: '/administration/users' }),
      } satisfies BreadcrumbHandle,
      children: [
        {
          index: true,
          Component: UserSearchPage,
        },
        {
          path: ':userId',
          Component: UserDetailPage,
          handle: {
            breadcrumb: ({ searchParams }) => ({
              label: searchParams.get('name')?.trim() || 'User Access Permissions',
            }),
          } satisfies BreadcrumbHandle,
        },
      ],
    },
  ],
};